import { isNonEmpty } from '@sgme/fp';

export function parseContentToGridData(rawContent: string, originCellId: string): Record<string, string> {
  const rows = rawContent.split('\n').filter(isNonEmpty);
  const gridData = rows.map(row => {
    return row
      .replaceAll('\r', '')
      .replaceAll(/[\t,;]/g, '|')
      .replaceAll(/\s\s+/g, '|')
      .split('|');
  });
  const originCellCoordinates = originCellId.split('-');
  const originRowIndex = parseInt(originCellCoordinates[0]);
  const originColumnIndex = parseInt(originCellCoordinates[1]);

  const parsedContent: Record<string, string> = {};

  gridData.forEach((row, rowIndex) => {
    row.forEach((column, columnIndex) => {
      if (isNonEmpty(column)) {
        const cellId = `${originRowIndex + rowIndex}-${originColumnIndex + columnIndex}`;
        parsedContent[cellId] = column;
      }
    });
  });
  return parsedContent;
}

export function isGridData(data: Record<string, string>): boolean {
  return Object.keys(data).length > 1;
}
